// extracted by mini-css-extract-plugin
export var active = "_ce-7";
export var container = "_ce-0";
export var evenWidth = "_ce-4";
export var large = "_ce-5";
export var outlet = "_ce-8";
export var slide = "_ce-2";
export var small = "_ce-6";
export var tab = "_ce-3";
export var tabs = "_ce-1";